/**
 * Resolve the API base from the compiled-in backend URL.
 *
 * Separate from `api.js` so it can be tested without constructing an axios
 * client and pulling in Clerk.
 *
 * Empty or unset means SAME ORIGIN — `/api` — which is what a deployment that
 * puts the app and the API behind one nginx wants. That shape needs no CORS
 * configuration at all and no public hostname baked into the bundle at build
 * time, which is otherwise unavoidable: `REACT_APP_*` is compile-time.
 */
export function apiBaseFrom(backendUrl) {
  const base = String(backendUrl ?? "").trim().replace(/\/+$/, "");
  return `${base}/api`;
}
